module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "keywords": _vm.keyword,
      "isSearch": _vm.path
    },
    on: {
      "tosearch": _vm.tosearch
    }
  }), _vm._v(" "), _c('div', {}, [(_vm.config) ? _c('div', {}, [_c('el-image', {
    staticClass: "topimg",
    attrs: {
      "src": _vm._f("addurl")(_vm.config.tzzximage),
      "fit": "fill"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "response bggray"
  }, [_c('div', {
    staticClass: "conwidth marginauto lall fadeInDown animated"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "marginauto bg-white flex justify-between align-center lone hvr-float",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id, _vm.tabindex)
        }
      }
    }, [_c('div', {
      staticClass: "pointer",
      staticStyle: {
        "min-height": "123px",
        "padding-left": "30px",
        "width": "100%"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "color": "#1d1d1d",
        "font-size": "22px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-cut2 response",
      staticStyle: {
        "margin": "15px 0",
        "min-height": "42px",
        "line-height": "30px"
      }
    }, [_vm._v("\n                                " + _vm._s(item.content) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between align-center"
    }, [_c('div', {
      staticStyle: {
        "color": "rgb(136, 136, 136)",
        "font-size": "18px"
      }
    }, [_vm._v("\n                                  发布日期："), _c('span', [_vm._v(_vm._s(item.createtime))])]), _vm._v(" "), _c('div', {
      staticClass: "dbtn pointer"
    }, [_vm._v("\n                                    查看详情\n                                ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center res",
    staticStyle: {
      "padding": "40px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pagerCount,
      "hide-on-single-page": true,
      "page-size": _vm.pagesize,
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 2)]) : _vm._e(), _vm._v(" "), (!_vm.list.length && !_vm.load) ? _c('div', {}, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de36e8f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/noticelist.vue
// module id = 421
// module chunks = 1